<template>
  <span
    class="flex items-center gap-2 text-sm"
    :class="[classWrapper, variant === 'inverse'
      ? invalid ? 'c-grey-60' : 'c-white'
      : invalid ? 'c-grey-30' : '']"
    data-test-id="vf-form-validation"
  >
    <vf-icon
      :class="[classIcon, variant === 'inverse'
        ? invalid ? 'c-grey-60' : 'c-green-30'
        : invalid ? 'c-grey-50 c-grey-30' : 'c-green-30']"
      :name="invalid ? 'clear' : 'success'"
      :size="iconSize"
    />
    <slot />
  </span>
</template>

<script lang="ts" setup>
import type { CSSClass, Responsive } from '#types/common'
import type { IconSizes } from '#types/sizes'

const { iconSize = { sm: 'md' }, invalid = true, variant } = defineProps<{
  classIcon?: CSSClass
  classWrapper?: CSSClass
  iconSize?: IconSizes | Partial<Responsive<IconSizes>>
  invalid?: boolean | string
  variant?: 'inverse'
}>()
</script>
